/**
 * @generated SignedSource<<17ed6dce24ecfa5848e2ca59e9208fbb>>
 * @relayHash 9cca1395e1647d3859a3fb01ec6154b5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82064c5ca9c1b1b160dab67e17cafff70a2902e489ccf1920ce01aea5d161781

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type VersionsEditWrapperQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type VersionsEditWrapperQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"VersionsEditWrapper">;
};
export type VersionsEditWrapperQuery = {
  response: VersionsEditWrapperQuery$data;
  variables: VersionsEditWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "VersionsEditWrapperQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          {
            "kind": "Variable",
            "name": "projectKey",
            "variableName": "projectKey"
          }
        ],
        "kind": "FragmentSpread",
        "name": "VersionsEditWrapper"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VersionsEditWrapperQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "key",
                "variableName": "projectKey"
              }
            ],
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "alias": "canEditVersions",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "MANAGE_VERSIONS"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canPerform"
                  }
                ],
                "storageKey": "action(type:\"MANAGE_VERSIONS\")"
              },
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "82064c5ca9c1b1b160dab67e17cafff70a2902e489ccf1920ce01aea5d161781",
    "metadata": {},
    "name": "VersionsEditWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ed7384953bff68d730f941f62079280a";

export default node;
